import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import usePageMeta from "@/hooks/usePageMeta";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import MovieSection from "@/pages/home/components/MovieSection";
import IntroSection from "@/pages/home/components/IntroSection";
import {
  categories,
  countByCategory,
  getHeroSlides,
  getHot,
  getLatest,
} from "@/utils/catalog";

const quickTags = [
  { label: "悬疑", to: "/search?q=%E6%82%AC%E7%96%91" },
  { label: "家庭", to: "/search?q=%E5%AE%B6%E5%BA%AD" },
  { label: "自然", to: "/search?q=%E8%87%AA%E7%84%B6" },
  { label: "治愈", to: "/search?q=%E6%B2%BB%E6%84%88" },
  { label: "高分", to: "/search?q=%E5%89%A7%E6%83%85" },
];

export default function Home() {
  usePageMeta(
    "黄色片免费看 - 多类别影片资源聚合平台",
    "黄色片免费看网站提供丰富多样的影片资源分类，涵盖各类热门影视内容，方便用户浏览和查找感兴趣的影片。",
  );

  const slides = getHeroSlides();
  const latest = getLatest(8);
  const hot = getHot(8);
  const counts: Record<string, number> = {};
  categories.forEach((item) => {
    counts[item.slug] = countByCategory(item.slug);
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-8 md:py-8">
          <section className="mb-5 flex flex-col gap-4 md:mb-6 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-[26px]">
                黄色片免费看 · 多类别影片资源聚合
              </h1>
              <p className="mt-2 max-w-[640px] text-sm leading-relaxed text-foreground-600">
                电影、剧集、纪录片、短片与动画，按分类浏览或直接搜索，找到今天想看的那一部。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-1.5">
              <span className="text-xs text-foreground-500">热门标签</span>
              {quickTags.map((tag) => (
                <Link
                  key={tag.label}
                  to={tag.to}
                  className="rounded-full border border-background-300 bg-background-50 px-2.5 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  {tag.label}
                </Link>
              ))}
            </div>
          </section>

          <HeroCarousel slides={slides} />

          <section className="mt-8 md:mt-10">
            <div className="flex flex-col gap-1.5">
              <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-primary-600">
                <span className="h-1 w-1 rounded-full bg-accent-500" />
                Browse by category
              </span>
              <h2 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                分类快捷入口
              </h2>
              <p className="text-sm text-foreground-500">
                五大类别覆盖不同观看场景，点进去即可看到该类别的全部资源。
              </p>
            </div>
            <div className="mt-5">
              <CategoryGrid counts={counts} />
            </div>
          </section>

          <section className="mt-8 md:mt-12">
            <MovieSection
              eyebrow="Fresh updates"
              title="最新影片推荐"
              subtitle="按更新时间排序，刚刚整理进来的影片都在这里。"
              movies={latest}
              actionTo="/category/movie"
              actionLabel="查看全部电影"
            />
          </section>

          <section className="mt-8 md:mt-10">
            <MovieSection
              eyebrow="Most watched"
              title="热门影片精选"
              subtitle="结合浏览热度与评分挑选，适合不知道看什么的时候直接点开。"
              movies={hot}
              actionTo="/search?q=%E5%89%A7%E6%83%85"
              actionLabel="发现更多"
              ranked
              tone="tinted"
            />
          </section>

          <section className="mt-8 md:mt-12">
            <IntroSection />
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}